import { ContractReview, ContractReviewFinding } from '../../../models/Entities/Contracts/ContractReview';
import { ContractReviewState } from '../../states/ContractReview.States';

/** De la más nueva a la más vieja (`created` desc), como la devuelve Contracts. */
export const sortByCreatedDesc = (reviews: ContractReview[]): ContractReview[] =>
  [...reviews].sort((a, b) => (b.created ?? '').localeCompare(a.created ?? ''));

/**
 * Funde un resumen (lista o polling) sobre el detalle que ya se tenía: actualiza estado, avance y contadores sin
 * perder `findings`, `conceptVerdicts`, `warnings` ni `extractionSummary`, que el resumen no trae.
 */
export const mergeReview = (existing: ContractReview | undefined, incoming: ContractReview): ContractReview =>
  existing
    ? {
        ...existing,
        ...incoming,
        findings: incoming.findings ?? existing.findings,
        conceptVerdicts: incoming.conceptVerdicts ?? existing.conceptVerdicts,
        warnings: incoming.warnings ?? existing.warnings,
        extractionSummary: incoming.extractionSummary ?? existing.extractionSummary
      }
    : incoming;

/** Reemplaza una revisión en las listas por contrato donde aparezca. */
export const replaceInLists = (
  lists: ContractReviewState['listByContract'],
  review: ContractReview
): ContractReviewState['listByContract'] => {
  const entry = lists[review.contractId];
  if (!entry) return lists;
  return {
    ...lists,
    [review.contractId]: { ...entry, items: entry.items.map(r => (r.id === review.id ? mergeReview(r, review) : r)) }
  };
};

/** Aplica `update` a los hallazgos de una revisión del detalle. */
export const updateFindings = (
  byId: ContractReviewState['byId'],
  reviewId: string,
  update: (finding: ContractReviewFinding) => ContractReviewFinding
): ContractReviewState['byId'] => {
  const review = byId[reviewId];
  if (!review?.findings) return byId;
  return { ...byId, [reviewId]: { ...review, findings: review.findings.map(update) } };
};
